// Utilitaires d'argent pour Cataley — stockage en CENTS, affichage français CAD.
export function fmtCAD(cents) {
  const v = (Number(cents || 0) / 100);
  return v.toLocaleString("fr-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " $";
}

// "2,50" ou "2.50" ou "2" → 250 (cents). Renvoie null si invalide.
export function parseDollarsToCents(str) {
  if (str === null || str === undefined) return null;
  const s = String(str).trim().replace(/\$/g, "").replace(/\s/g, "").replace(",", ".");
  if (s === "") return null;
  const v = Number(s);
  if (!isFinite(v) || v < 0) return null;
  return Math.round(v * 100);
}
